// extracted by mini-css-extract-plugin
export default {"root":"root--SXbgM","clear":"clear--SXbgM"};